export const SEND_FEEDBACK = 'FEEDBACK/SEND';
export const SEND_FEEDBACK_ERROR = 'FEEDBACK/SEND_ERROR';



// WEBPACK FOOTER //
// ./src/store/modules/feedback/types.js